import React from 'react';
import XLSX from 'xlsx';
import CreateNewFolderIcon from '@material-ui/icons/CreateNewFolder';
import Fab from '@material-ui/core/Fab';
import { createOid } from '@/utils/eventtracing';
import { Controller, useForm } from 'react-hook-form';
import Input from '@material-ui/core/Input';
import ImportStyled from './ImportStyled';

const Import = (props) => {
  // //国际化
  // const intl = useIntl();
  // const { formatMessage } = intl;
  const { name, onInputChange } = props;
  const { control } = useForm();
  return (
    <ImportStyled>
      <Fab
        data-log={JSON.stringify({
          oid: createOid('ec'),
          events: ['_ev', '_ec'],
          params: {
            initUrl: window.location.origin + window.location.pathname,
          },
        })}
        variant="extended"
        size="small"
        color="primary"
        aria-label="add"

        // disabled={disabled}
        // className={classes.margin}
      >
        <CreateNewFolderIcon sx={{ width: '24px', height: '24px' }} />
        {name}
        <Controller
          render={(rp) => {
            return (
              <Input
                name="file"
                type="file"
                id="inputFile"
                // rules={{
                //   required: true,
                // }}
                accept=".xlsx,.xls"
                label="上传文件"
                onChange={(e) => {
                  const fileList = e.target.files;
                  let file = fileList[0];
                  const fileReader = new FileReader();
                  fileReader.readAsBinaryString(file);
                  let data = [];
                  fileReader.onload = (event) => {
                    try {
                      const { result } = event.target;
                      const workbook = XLSX.read(result, { type: 'binary' });
                      for (const sheet in workbook.Sheets) {
                        // eslint-disable-next-line no-prototype-builtins
                        if (workbook.Sheets.hasOwnProperty(sheet)) {
                          // 利用 sheet_to_json 方法将 excel 转成 json 数据
                          data = data.concat(
                            XLSX.utils.sheet_to_json(workbook.Sheets[sheet], {
                              defval: null,
                            }),
                          );
                          // break;
                          // 如果只取第一张表，就取消注释这行
                        }
                      }
                      onInputChange(data);
                      console.log(data, '=====');
                      // 清空文件, 否则选取相同的文件不会触发 onChange 函数
                      e.target.value = null;
                      // eslint-disable-next-line no-catch-shadow
                    } catch (error) {
                      console.log('类型错误');
                      console.log(error);
                      return;
                    }
                  };

                  return rp.onChange(e);
                }}
              />
            );
          }}
          name="file"
          type="file"
          label="导入文件"
          control={control}
          // defaultValue=""
        />
      </Fab>
    </ImportStyled>
  );
};
export default Import;
